import httpRequest from "@/auth/http-client";
import { buildPaginationQuery } from "@/helpers/request-helpers";
import { IProductImage } from "@/interfaces/product-image.interface";
import { IFilter } from "@/types/filter.types";
import { PaginatedResponse, RequestPagination } from "@/types/requests.types";

class ProductImageService {
  private baseUrl = "api/v1/productimage";

  async getAll(pagination: RequestPagination): Promise<PaginatedResponse<IProductImage>> {
    const paginationQuery = buildPaginationQuery(pagination);
    const productImages = await httpRequest.get(`${this.baseUrl}?${paginationQuery}`);
    return productImages;
  }

  async filter(
    filter: IFilter<IProductImage>[],
    pagination: RequestPagination
  ): Promise<PaginatedResponse<IProductImage>> {
    const paginationQuery = buildPaginationQuery(pagination);

    const response = await httpRequest.post(`${this.baseUrl}/filter?${paginationQuery}`, {
      filter,
    });

    return response;
  }

  async create(formData: FormData): Promise<FormData> {
    const response = await httpRequest.post(`${this.baseUrl}`, formData, {
      headers: {
        // Override default to allow Axios to set correct multipart boundary
        "Content-Type": "multipart/form-data",
      },
    });

    return response;
  }

  async getById(productImageId: number): Promise<IProductImage> {
    const productImage = await httpRequest.get(`${this.baseUrl}/${productImageId}`);

    return productImage;
  }

  async delete(productImageId: number): Promise<void> {
    await httpRequest.delete(`${this.baseUrl}/${productImageId}`);
  }

  //  método para atualizar a imagem principal
  async updateMainImage(productId: number, imageId: number): Promise<void> {
    await httpRequest.put(`${this.baseUrl}/main/${productId}/${imageId}`);
  }
}

const productImageService = new ProductImageService();
export default productImageService;
